type ToggleIndexAction = {
  type: "toggle_index";
  payload: number;
};
export type OfferingFormCheckoutFormQuestionAccordionActions = ToggleIndexAction;

export type OfferingFormCheckoutFormQuestionAccordionState = {
  openIndexes: number[];
};

export const initialOfferingFormCheckoutFormQuestionAccordionState: OfferingFormCheckoutFormQuestionAccordionState =
  {
    openIndexes: [0],
  };

export const offeringFormCheckoutFormQuestionAccordionReducer = (
  state: OfferingFormCheckoutFormQuestionAccordionState = initialOfferingFormCheckoutFormQuestionAccordionState,
  action: OfferingFormCheckoutFormQuestionAccordionActions
) => {
  if (action.type === "toggle_index") {
    const closing = state.openIndexes.includes(action.payload);
    return closing
      ? {openIndexes: state.openIndexes.filter((i) => i !== action.payload)}
      : {...state, openIndexes: [...state.openIndexes, action.payload]};
  }
  return state;
};
